import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../api/axiosInstance";
export const postPaymentSettingsFunc = createAsyncThunk(
  "add payment settings function",
  async ({ data }, thunkAPI) => {
    try {
      const res = await api.post(
        `dashboard/general-settings/payment-gateway-settings`,
        data
      );
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const postPaymentSettingsSlicer = createSlice({
  name: "add payment settings function",
  initialState: {
    loading: false,
    data: [],
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postPaymentSettingsFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(postPaymentSettingsFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(postPaymentSettingsFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default postPaymentSettingsSlicer.reducer;
